<template>
	<section class="sk-inner-picker">
		<select class="sk-picker-field sk-picker-field-year" v-model="year" @change="onChange">
			<option v-for="item in collectionYear" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
	</section>
</template>

<script>
import moment from 'moment'
export default {
	name: 'picker-year',
	data() {
		return {
			year: moment().year(),
			month: 0,
			day: 0,
			hour: 0,
			minute: 0,
		}
	},
	computed: {
		collectionYear() {
			const collection = []

			for (let value = 2000; value < 2100; value++) {
				collection.push({
					key: value,
					name: value
				})
			}

			return collection
		},
	},
	methods: {
		onChange() {
			this.$emit('change', {
				year: this.year,
				month: this.month + 1,
				day: this.day,
				hour: this.hour,
				minute: this.minute,
			})
		}
	},
	created() {
		this.$emit('change', {
			year: this.year,
			month: this.month === 0 ? 0 : this.month + 1,
			day: this.day,
			hour: this.hour,
			minute: this.minute,
		})
	}
}
</script>

<style scope>
.sk-picker-field-year {
	width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/modules/datetime/PickerYear.vue